import { ProcessCellForExportParams, GridApi } from 'ag-grid-community'
import { useCallback } from 'react'
import { exportExcel } from '../../../containers/BulkSheet/excel'
import { useDialogState } from '../../../components/dialogs/useDialogState'
import { TaskActualWorkApprovalStatusRow } from '../taskActualWorkApprovalStatus'
import { getRequestStatusLabel } from '../gridOptions'
import { DecimalAndSexagesimalScale } from '../../../../lib/functions/decimalAndSexagesimalScale'
import { convertDecimalHourToHM } from '../../../../utils/time'

export const useExcel = (
  gridApi: GridApi | undefined,
  gridContext: { decimalScaleUnit: DecimalAndSexagesimalScale }
) => {
  const [dialogOpen, openDialog, closeDialog] = useDialogState()

  const customExportValues = useCallback(
    (params: ProcessCellForExportParams<TaskActualWorkApprovalStatusRow>) => {
      if (!params.node) return undefined
      const columnId: string = params.column.getColId()
      const row: TaskActualWorkApprovalStatusRow | undefined = params.node.data

      if (columnId === 'rowNumber') {
        return (params?.node?.rowIndex ?? 0) + 1
      }

      if (columnId === 'userName') {
        return row?.userName ?? ''
      }

      if (columnId === 'division') {
        return row?.division ?? ''
      }

      if (columnId === 'position') {
        return row?.position ?? ''
      }

      if (columnId === 'requestStatus') {
        return row?.requestStatus
          ? getRequestStatusLabel(row.requestStatus)
          : ''
      }

      const timeColumns = [
        'totalWorkingTime',
        'totalActualWorkingHour',
        'requestedHour',
        'unRequestedHour',
        'actualWorkHourThisProject',
        'requestedHourThisProject',
        'unRequestedHourThisProject',
        'approvedHourThisProject',
        'unApprovedHourThisProject',
        'sentBackHourThisProject',
        'plannedManHour',
        'actualManHour',
      ]

      if (
        timeColumns.includes(columnId) &&
        params.value !== undefined &&
        params.value !== null
      ) {
        if (
          gridContext.decimalScaleUnit ===
          DecimalAndSexagesimalScale.SEXAGESIMAL
        ) {
          const converted = convertDecimalHourToHM(params.value)
          return converted || ''
        }
        const formatted =
          typeof params.value === 'number'
            ? params.value.toFixed(2)
            : params.value
        return formatted
      }

      if (typeof params.value === 'object' && params.value !== null) {
        return params.value.name ?? params.value.displayName ?? ''
      }

      return undefined
    },
    [gridContext]
  )

  const onExportExcel = useCallback(
    (colIds: string[]) => {
      if (!colIds || colIds.length === 0 || !gridApi) return
      exportExcel({
        fileNamePrefix: 'task_actual_work_approval_status',
        gridApi,
        exportColIds: colIds,
        getCustomExportValue: customExportValues,
        shouldRowBeSkipped: params =>
          !params.node.data || !params.node.displayed,
      })
    },
    [gridApi, customExportValues]
  )

  return {
    dialogOpen,
    openDialog,
    closeDialog,
    onExportExcel,
  }
}
